import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@ro-atoms/Icon';
import { Container, IconWrapper } from './MenuItem.styles';
import { Props } from './MenuItem.types';

const MenuItem = (props: Props) => {
  return (
    <Link to={props.to}>
      <Container className={props.className}>
        {props.icon && (
          <IconWrapper>
            <Icon name={props.icon} />
          </IconWrapper>
        )}
        {props.text}
      </Container>
    </Link>
  );
};
export default MenuItem;
